module.exports = __webpack_public_path__ + "img/carema2.fbc58495.svg";